import { Message } from "~/shared/ui/kit/components/Message"
import type { MessageProps } from "~/shared/ui/kit/components/Message"

export interface FieldMessageProps extends MessageProps {
	show: boolean
}

export function FieldMessage({ show, children, ...props }: FieldMessageProps) {
	return show ? (
		<Message {...props} style={{ width: "fit-content" }}>
			{children}
		</Message>
	) : null
}
